import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import api, { resolveAsset } from "../../lib/api";

const TestimonialsPreview = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials", { params: { active_only: true } })
      .then((r) => setItems(r.data.slice(0, 4)))
      .catch(() => {});
  }, []);

  return (
    <section id="testimonials-preview" className="py-16 sm:py-24" data-testid="testimonials-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div className="max-w-xl">
            <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Parents say</span>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold mt-2">
              Stories from our community
            </h2>
          </div>
          <Link to="/testimonials" className="btn-ghost" data-testid="testimonials-view-all">
            Read all stories <ArrowRight size={16} />
          </Link>
        </div>

        {items.length === 0 ? (
          <p className="text-center text-[color:var(--text-secondary)]">Stories will appear here once added.</p>
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {items.map((t, i) => (
              <div key={t.id} className="card-soft p-7 sm:p-8 bg-white" data-testid={`testimonial-${i}`}>
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: t.rating || 5 }).map((_, k) => (
                    <Star key={k} size={16} className="fill-brand-yellow text-brand-yellow" />
                  ))}
                </div>
                <p className="text-[color:var(--text-primary)] leading-relaxed">"{t.message}"</p>
                <div className="mt-5 flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full bg-light-blue flex items-center justify-center font-heading font-bold text-brand-blue">
                    {t.photo_url ? (
                      <img src={resolveAsset(t.photo_url)} alt={t.name} className="w-full h-full rounded-full object-cover" />
                    ) : t.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-heading font-bold text-sm">{t.name}</div>
                    <div className="text-xs text-[color:var(--text-secondary)]">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default TestimonialsPreview;
